export default __webpack_public_path__ + "static/media/mic.19500b03.svg";